export default __webpack_public_path__ + "static/destination-b117b3f8f25138920cedc98980863820.jpeg";